var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar"},[_c('img',{staticClass:"img",attrs:{"src":_vm.avatarUrl||require('../assets/images/avatar.jpg')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }